function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 4.72754,
  y: 2.86328,
  width: 6.36364,
  height: 6.36364,
  rx: 3.18182,
  fill: "white",
  stroke: "#98A7B8",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M2 14.8633C2 13.7587 2.89543 12.8633 4 12.8633H12.1569C13.2614 12.8633 14.1569 13.7587 14.1569 14.8633V19.136C14.1569 19.6883 13.7091 20.136 13.1569 20.136H3C2.44772 20.136 2 19.6883 2 19.136V14.8633Z",
  fill: "white",
  stroke: "#98A7B8",
  strokeWidth: 2
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 13.7646,
  y: 5.58984,
  width: 5.45455,
  height: 5.45455,
  rx: 2.72727,
  fill: "white",
  stroke: "#98A7B8",
  strokeWidth: 2
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M9.84277 15.6699C9.84277 14.5654 10.7382 13.6699 11.8428 13.6699H19.9996C21.1042 13.6699 21.9996 14.5654 21.9996 15.6699V19.1346C21.9996 19.6869 21.5519 20.1346 20.9996 20.1346H10.8428C10.2905 20.1346 9.84277 19.6869 9.84277 19.1346V15.6699Z",
  fill: "white",
  stroke: "#98A7B8",
  strokeWidth: 2
});

function SvgGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.a99b1626.svg";
export { ForwardRef as ReactComponent };